import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import Tweet from './Tweet';
import './Tweets.css';
import twitterImage from '../../img/twitter.png';
import imageOne from '../../img/tweets/tweet1.jpeg';
import imageTwo from '../../img/tweets/tweet2.jpg';
import imageFour from '../../img/tweets/tweet4.jpg';

class Tweets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tweets: [
        {
          link: 'https://twitter.com/chrisratcliff/status/996030738251337728',
          image: imageOne,
          author: '@chrisratcliff',
          text: 'A certificate per bottle is interesting, especially with a tamper evident enclosure. More crypto than Glenlievet’s Cipher :)',
        },
        {
          link: 'https://twitter.com/whiskycast/status/995794125160054784',
          image: imageTwo,
          author: '@whiskycast',
          text: 'Waiting for the first #blockchain whisky...come on, you know someone is working on the idea as we speak! ',
        },
        {
          link: 'https://twitter.com/DJStoney/status/938502325722910720',
          image: imageFour,
          author: '@DJStoney',
          text: 'First ever #BEER on a #BLOCKCHAIN – yes, seriously. A partnership with tech firm @arcnetHQ and @IreCraftBeer Imagine Budweiser 2012 "Track your bud" campaign taken to the next level!',
        },
      ],
    };
  }

  render() {
    const tweets = this.state.tweets.map((tweet, i) => (
      <Fade delay={i * 400} key={tweet.author}>
        <a
          href={tweet.link}
          target="_blank"
          rel="noopener noreferrer"
          className="tweet-link"
        >
          <Col s={6} xs={12} md={3} className="tweet">
            <Tweet
              userImage={tweet.image}
              twitterImage={twitterImage}
              text={tweet.text}
              author={tweet.author}
            />
          </Col>
        </a>
      </Fade>
    ));

    return (
      <div className="tweets">
        <Grid>
          <Fade>
            <Row className="header">
              <h1> What consumers say about Distilled ID</h1>
            </Row>
          </Fade>
          <Row className="tweet-row">{tweets}</Row>
        </Grid>
      </div>
    );
  }
}

export default Tweets;



// WEBPACK FOOTER //
// ./src/components/common/Tweets.js